import Header from './components/Header';
import Hero from './components/Hero';
import FAQ from './components/FAQ';
import Topics from './components/Topics';
import AppDownload from './components/AppDownload';
import Cards from './components/Cards';
import Updates from './components/Updates';
import Ranking from './components/Ranking';
import Carousel from './components/Carousel';
import About from './components/About';
import Features from './components/Features';
import Media from './components/Media';
import Contact from './components/Contact';
import Index from './components/Index';
import Comments from './components/Comments';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FAQ />
        <Topics />
        <AppDownload />
        <Cards />
        <Updates />
        <Ranking />
        <Carousel />
        <About />
        <Features />
        <Media />
        <Contact />
        <Index />
        <Comments />
      </main>
      <Footer />
    </div>
  );
}